module.exports = __webpack_public_path__ + "img/health-insurance.7f9800a2.svg";